import React from 'react';
import { Copy, KeyRound } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { copyText, credentialsText } from './consoleUtils';

export const CredentialsDialog = ({ creds, onClose }) => {
  if (!creds) return null;
  const text = credentialsText(creds.email, creds.password);
  return (
    <Dialog open={!!creds} onOpenChange={onClose}>
      <DialogContent className="bg-card border-border max-w-md" data-testid="credentials-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-primary" /> {creds.title}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Send these to the employee yourself. The password is shown only once.</p>
        <pre className="text-xs bg-muted/40 border border-border/50 rounded-md p-3 whitespace-pre-wrap break-all font-mono" data-testid="credentials-text">{text}</pre>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onClose} data-testid="btn-close-credentials">Done</Button>
          <Button size="sm" onClick={() => copyText(text, 'Login details copied')} data-testid="btn-copy-credentials">
            <Copy className="w-3.5 h-3.5 mr-1" /> Copy login details
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
